<script>
    import { ValueService } from '../../services/ValueService.js';
    import { getContext, setContext } from 'svelte';

    /**
     * @typedef {import('../../services/ValueService.js').ValueCssColor} ValueCssColor
     */

    /**
     * @type {{
     *     bg?: boolean | string | null,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { bg = null, children } = $props();

    const tableBg = $derived(getContext('ly-table-colors')?.value?.next);
    const useBg = $derived(bg !== null ? bg : (tableBg ?? true));

    /** @type {{value:ValueCssColor|null}} */
    let colors = $state({ value: null });
    $effect(() => {
        colors.value = ValueService.splitCssColor(useBg, true);
    });
    setContext('ly-table-tbody-colors', colors);
    const thisDivide = $derived(colors.value?.divide || '');

    // -
    const bodyRowCounter = $state({ value: 0 });
    setContext('ly-table-tbody-row-counter', bodyRowCounter);
</script>

<tbody class="{colors.value?.bg1 || ''} divide-y {thisDivide}">
    {@render children?.()}
</tbody>
